import request from '@/utils/zsm-requets'
const complainant = '/zsm/api/complainant/'
import Qs from 'qs' //处理格式

/**
 * 创建投诉
 * @param orderNo 订单号
 * @param orderId 订单号
 * @param complainant_mobile 投诉人手机号
 * @param complainant_name 投诉人名称
 * @param complainant_head_picture 投诉人头像
 * @param complainant_description 投诉描述
 * @param complainant_certificate 投诉凭证
 */
export function createComplainant(data) {
  return request({
    headers: {
      'Content-Type': 'application/json'
    },
    url: complainant + 'createComplainant',
    method: 'post',
    transformRequest: [function(data) {
      data = JSON.stringify(data)
      return data
    }],
    data
  })
}

/**
 * 投诉工单详情
 * @param id 编号
 */
export function getComplainant(params) {
  return request({
    headers: {
      'Content-Type': 'application/json'
    },
    url: complainant + 'getComplainant',
    method: 'get',
    params
  })
}

/**
 * 投诉单列表查询
 * @param orderNo 订单号
 * @param orderId 订单号
 * @param complainant_mobile 投诉人手机号
 * @param complainant_name 投诉人名称
 * @param complainant_head_picture 投诉人头像
 * @param complainant_description 投诉描述
 * @param complainant_certificate 投诉凭证
 * @param id 投诉单 id
 * @param title 课程标题
 */

export function findComplainant(params) {
  return request({
    url: complainant + 'getComplainantData',
    method: 'post',
    params
  })
  // return request({
  //   headers: {
  //     'Content-Type': 'application/json'
  //   },
  //   url: complainant + 'getComplainantData',
  //   method: 'post',
  //   transformRequest: [function(data) {
  //     data = JSON.stringify(data)
  //     return data
  //   }],
  //   data
  // })
}


/**
 * 投诉统计
 * @param endDate 结束时间
 * @param startDate 开始时间
 * @param authorMobile 讲师手机号
 * */
export function getComplainantStatistics(params) {
  return request({
    url: complainant + 'getComplainantStatistics',
    method: 'post',
    data: Qs.stringify(params)
  })
}
/**
 * 讲师处理投诉单
 * @param orderNo 订单号
 * @param orderId 订单号
 * @param complainant_mobile 投诉人手机号
 * @param complainant_name 投诉人名称
 * @param complainant_head_picture 投诉人头像
 * @param complainant_description 投诉描述
 * @param complainant_certificate 投诉凭证
 * @param id 投诉单 id
 * @param title 课程标题
 */
export function updateComplainantOrder(data) {
  return request({
    headers: {
      'Content-Type': 'application/json'
    },
    url: complainant + 'updateComplainantOrder',
    method: 'post',
    transformRequest: [function(data) {
      data = JSON.stringify(data)
      return data
    }],
    data
  })
}

